<template>
    <m-filter text="Name" :popup.sync="popup" :filtered="filtered">
        <m-lookup :data="names" @select="select"></m-lookup>
    </m-filter>
</template>

<script>
import Ajax from '@/js/ajax'

export default {
    props: {
        value: Object,
        url: String
    },
    data: () => ({
        names: [],
        popup: false
    }),
    mounted() {
        Ajax.get(this.url).then(res => {
            this.names = res.map(x => ({ value: x, text: x }))
        })
    },
    methods: {
        select(name) {
            this.$emit('input', name)
            this.popup = false
        }
    },
    computed: {
        filtered() {
            if (!this.value) {
                return ''
            }
            return this.value?.value || this.value?.text || ""
        }
    }
}
</script>
